export default "__VITE_ASSET__BjZuk_Tr__"